import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { FiMoreVertical, FiSearch } from "react-icons/fi";
import Breadcrumbs from "../../common/Breadcrumbs/Breadcrumbs";
import { SidebarImg } from "../../../static/constant/imgConstants";
import DataTable from "react-data-table-component";

import {
    getCampaignListWithFilter
} from "../../../store/influencerCampaignStore/actions/InfluencerCampaignActions/getCampaignListFilterActions";
import Footer from "../../common/Footer/Footer";

const getStatusStyle = (status) => {
    switch (status) {
        case 'APPROVED':
            return 'bg-[#00B69B] text-[#FFFFFF]';
        case 'PENDING_APPROVAL':
            return 'bg-[#FCBE2D] text-[#FFFFFF]';
        case 'REJECTED':
            return 'bg-[#FD5454] text-[#FFFFFF]';
        default:
            return 'bg-[#FCBE2D] text-[#FFFFFF]';
    }
};

// Campaign Card component for mobile view
const CampaignCard = ({ campaign, onViewDetails }) => (
    <div className="bg-white rounded-lg shadow-md p-4 mb-4 border border-gray-300">
        <div className="flex flex-col space-y-3">
            {/* Campaign Name - Larger Font */}
            <div>
                <span className="text-[1.6rem] font-medium">{campaign.name}</span>
            </div>

            {/* Purpose */}
            <div className="flex items-center">
                <span className="text-[1.4rem] font-bold  w-32">Purpose:</span>
                <span className="text-[1.4rem]">{campaign.purpose}</span>
            </div>

            {/* Platform */}
            <div className="flex items-center">
                <span className="text-[1.4rem] font-bold w-32">Platform:</span>
                <span className="text-[1.4rem]">{campaign.platform}</span>
            </div>

            {/* Campaign Type */}
            <div className="flex items-center">
                <span className="text-[1.4rem] font-bold  w-32">Campaign Type:</span>
                <span className="text-[1.4rem]">{campaign.campaignType}</span>
            </div>

            {/* Status */}
            <div className="flex items-center">
                <span className="text-[1.4rem] font-bold  w-32">Status:</span>
                <span className={`text-[1.4rem] px-2 py-1 rounded-full ${getStatusStyle(campaign.status)}`}>
                    {campaign.status}
                </span>
            </div>

            {/* Start Date */}
            <div className="flex items-center">
                <span className="text-[1.4rem] font-bold  w-32">Start Date:</span>
                <span className="text-[1.4rem]">{campaign.startDate}</span>
            </div>

            {/* End Date */}
            <div className="flex items-center">
                <span className="text-[1.4rem] font-bold  w-32">End Date:</span>
                <span className="text-[1.4rem]">{campaign.endDate}</span>
            </div>

            {/* Action Button */}
            <div className="mt-2">
                <button
                    className="bg-blue-500 text-white text-[1.4rem] px-4 py-2 rounded w-full"
                    onClick={() => onViewDetails(campaign)}
                >
                    View Details
                </button>
            </div>
        </div>
    </div>
);


const CampaignsList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // const {campaignListFilterData} =  useSelector(state => state.getCampaignListFilterReducer)

    const [searchQuery, setSearchQuery] = useState('');
    const [filteredCampaigns, setFilteredCampaigns] = useState([]);
    const [campaignListFilterData, setCampaignListFilterData] = useState([]);
    const [statusFilter, setStatusFilter] = useState('ALL');
    const [isMobile, setIsMobile] = useState(false);



    const columns = [
        {
            name: 'Campaign',
            selector: row => row.name,
            sortable: true,
            style: {
                width: '10rem',  // Set a smaller width for this column
            },
            wrap: true,
        },
        {
            name: 'Purpose',
            selector: row => row.purpose,
            sortable: true,
            style: {
                width: '10rem',  // Adjust the width as needed
            },
            wrap: true,
        },
        {
            name: 'Platform',
            selector: row => row.platform,
            style: {
                width: '10rem',  // Set a smaller width for this column
            },
        },
        {
            name: 'Status',
            selector: row => row.status,
            style: {
                width: '10rem',  // Set a smaller width for this column
            },
        },
        {
            name: 'Campaign Type',
            selector: row => row.campaignType,
            style: {
                width: '10rem',  // Adjust the width for consistency
            },
        }/*,
        {
            name: 'Status',
            selector: row => (
                <span
                    className={`inline-block px-3 py-1 rounded-full text-center ${getStatusStyle(row.campaignStatus)}`}
                >
                    {row.campaignStatus}
                </span>
            ),
            style: {
                width: '90rem',
            },
        }*/,
        {
            name: 'Start Date',
            selector: row => row.startDate,
            style: {
                width: '10rem',  // Set a smaller width for this column
            },
        },
        {
            name: 'End Date',
            selector: row => row.endDate,
            style: {
                width: '10rem',  // Set a smaller width for this column
            },
        },
        {
            name: 'Action',
            cell: row => (
                <button
                    className="bg-blue-500 text-white px-4 py-2 rounded"
                    onClick={() => handleViewDetails(row)}
                >
                    View Details
                </button>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            style: {
                width: '10rem', // Adjust width for the Action column
            },
        },

    ];

    const getStatusStyle = (status) => {
        switch (status) {
            case 'APPROVED':
                return 'bg-[#00B69B] text-[#FFFFFF]';
            case 'PENDING_APPROVAL':
                return 'bg-[#FCBE2D] text-[#FFFFFF]';
            case 'REJECTED':
                return 'bg-[#FD5454] text-[#FFFFFF]';
            default:
                return 'bg-[#FCBE2D] text-[#FFFFFF]';
        }
    };


    useEffect(() => {
        dispatch(getCampaignListWithFilter({
            "campaignType": null,
            "startDate": null,
            "endDate": null,
            "status": statusFilter
        }, (status, response, message) => {
            console.log("for Campaign list status, response, message", status, response, message)
            if (status === 200) {
                const sorted = [...response].sort((a, b) => b.campaignId - a.campaignId); // Sort data by campaignId descending

                setCampaignListFilterData(sorted)
                setFilteredCampaigns(sorted)
            }
        }));
    }, [statusFilter]);

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };
    const handleViewDetails = (campaign) => {
        navigate('/influencer/campaigns/details', { state: { campaign } });
    };


    useEffect(() => {
        if (searchQuery === '') {
            setFilteredCampaigns(campaignListFilterData);
        } else {
            const filtered = campaignListFilterData.filter(campaign =>
                campaign.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                campaign.purpose.toLowerCase().includes(searchQuery.toLowerCase()) ||
                campaign.platform.toLowerCase().includes(searchQuery.toLowerCase()) ||
                campaign.campaignType.toLowerCase().includes(searchQuery.toLowerCase())
            );
            setFilteredCampaigns(filtered);
        }
    }, [searchQuery, campaignListFilterData]);
    
    useEffect(() => {
        const checkIfMobile = () => {
            setIsMobile(window.innerWidth < 768); // 768px is typical tablet breakpoint
        };

        // Set initial value
        checkIfMobile();

        // Add event listener for window resize
        window.addEventListener('resize', checkIfMobile);

        // Clean up
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);

    const customTableStyles = {
        table: {
            style: {
                position: 'relative',
            },
        },
        headRow: {
            style: {
                backgroundColor: '#F1F4F9',
                minHeight: '52px',
                fontWeight: 700,
                borderRadius: '0.4rem',
                borderBottom: 'none',
                // position: 'fixed',
                top: 0,
            },
            denseStyle: {
                minHeight: '32px',
            },
        },
        rows: {
            style: {
                fontSize: '1.4rem',  // Increased text size for rows
                fontWeight: 600,
                color: '#202224',
                borderBottom: '1px solid #EDEFF1',
                minHeight: '70px',
            },
            denseStyle: {
                minHeight: '40px',
            },
        },
        headCells: {
            style: {
                padding: '1rem',
                fontSize: '1.6rem',
                textAlign: 'left',
            },
        },
        cells: {
            style: {
                padding: '1.5rem',
            },
        },
    };


    return (
        <div className="w-full h-full flex flex-col bg-[#F2F3F7] overflow-auto">
            <Breadcrumbs breadcrumbs={[{ label: 'Home', href: '/' }, { label: 'My Campaigns', href: '/influencer/campaigns' }]} />
            <div className="w-full flex justify-between items-center py-[3rem] ">
                <div className="relative px-[4rem] py-[1rem] ">
                    <FiSearch className="absolute top-1/2 left-20 transform -translate-y-1/2 w-[2.1rem] h-[2.1rem] text-gray-400" />
                    <input
                        type="text"
                        value={searchQuery}
                        onChange={handleSearchChange}
                        placeholder="Search Campaigns"
                        className="w-[20rem] p-3 border text-[1.4rem] inter-font font-[400] border-gray-300 rounded-[0.3rem] pl-16 outline-none"
                    />
                </div>
            </div>
            <div className="w-full h-full flex flex-col px-[4rem]">
                <div className="w-full flex flex-col rounded-[2.6rem] bg-[#ffffff] p-[2.4rem]">
                    {/* Header Section */}
                    <div className="flex justify-between items-center  sticky top-0 z-10 bg-[#ffffff] py-[2.4rem]">
                        <h1 className="text-[2.4rem] inter-font font-[700]">Campaigns</h1>
                        <div>
                            <select
                                className="border-2 border-gray-300 p-3 pr-14 rounded-md text-[1.4rem] inter-font font-[400] outline-none"
                                onChange={(e) => {
                                    setStatusFilter(e.target.value);
                                }}
                            >
                                <option value="ALL">All</option>
                                <option value="OPTED">Opted</option>
                                <option value="NOT_OPTED">Not Opted</option>
                                <option value="LOCKED">Locked-In</option>
                            </select>
                        </div>
                    </div>

                    {/* Table Container */}
                    <div className="w-full max-h-[50rem] overflow-y-auto no-scrollbar pb-[2.4rem]">
                        {Array.isArray(filteredCampaigns) && filteredCampaigns.length > 0 ? (
                            isMobile ? (
                                // Mobile view - Cards
                                <div className="flex flex-col space-y-4">
                                    {filteredCampaigns.map((campaign, index) => (
                                        <CampaignCard
                                            key={index}
                                            campaign={campaign}
                                            onViewDetails={handleViewDetails}
                                        />
                                    ))}
                                </div>
                            ) : (
                                // Desktop view - Table
                                <DataTable
                                    columns={columns}
                                    data={filteredCampaigns}
                                    customStyles={customTableStyles}
                                    pagination
                                    highlightOnHover
                                    responsive
                                />
                            )
                        ) : (
                            <div className="text-2xl md:text-4xl leading-[50px] md:leading-[70px] text-gray-500 text-center mt-4">
                                There are no records to display.
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    );
};

export default CampaignsList;
